// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2yalr","itemTitle":"ClientEmergencyInfo_itemTitle__1jmVT","itemText":"ClientEmergencyInfo_itemText__31MG9"};